import { settings } from '../settings';
import Fetch from './fetch';

export const checkBackendAccess = async (): Promise<boolean> => {
  const url = `${settings.newApiUrl}/user/me`;
  const response = await Fetch.get({ url });
  return !(response.status === 401 || response.status === 403);
};
